module.exports = __webpack_public_path__ + "static/media/eu.a07a8bb7.svg";